import { useRef } from "react";

import { type FilesUploader } from "../core";

export const useFilesUploader = ({
  uploader,
}: {
  uploader: InstanceType<typeof FilesUploader>;
}) => {
  const inputRef = useRef<HTMLInputElement>(null);

  const handleClick = () => {
    if (!inputRef.current) return;

    inputRef.current.click();
  };

  const handleDrop = async (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault();

    uploader.cancelAll();

    try {
      await uploader.addFilesFromDragEvent(event as unknown as Event);

      uploader.upload();
    } catch (error) {
      console.log(error);
    }
  };

  const handleInputChange = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    if (!uploader) return;

    const input = event.currentTarget;
    const { files } = input;

    if (!files) throw new Error("No files selected");

    uploader.cancelAll();

    try {
      await uploader.addFilesFromInput(files);

      uploader.upload();
    } catch (error) {
      console.log(error);
    } finally {
      input.value = "";
    }
  };

  return {
    handleClick,
    handleInputChange,
    handleDrop,
    inputRef,
    allowedFileExtensions: uploader.allowedFileExtensions().join(","),
  };
};
